import React, { ReactElement } from 'react'
import { ThemeProvider } from 'styled-components'

declare module 'styled-components' {
  export interface DefaultTheme {
    darkMode?: boolean
  }
}

const StyledThemeProvider: React.FC<{ darkMode: boolean, children: ReactElement }> = ({
  darkMode,
  children,
}) => {
  return <ThemeProvider theme={{ darkMode }}>{children}</ThemeProvider>
}

export default StyledThemeProvider
